export default __webpack_public_path__ + "static/media/twitter.66a97d15.svg";